import { absenceTaskReference } from '@src/features/absence';
import { clientTaskReference } from '@src/features/clients';
import { registerTaskReferenceResolvers } from '@src/features/tasks';
import {
  qualificationTaskReference,
  scheduleTaskReference,
} from '@src/features/users';

/**
 * Every section that raises tasks, and where its references open.
 *
 * The one place that knows all of them, and it sits above the features so none
 * of them has to know another: the task list asks for a route, the section
 * that wrote the reference decides what that means. The backend is arranged
 * the same way -- each Django app claims its reference type in `ready()`, and
 * `task_management` never learns the list.
 *
 * Imported for its effect, before anything renders, so a reference clicked on
 * the first paint already has somewhere to go.
 */
registerTaskReferenceResolvers({
  absence: absenceTaskReference,
  clients: clientTaskReference,
  qualification: qualificationTaskReference,
  schedule: scheduleTaskReference,
});
